import { render, staticRenderFns } from "./AssetSelector.vue?vue&type=template&id=7bb39622&scoped=true&"
import script from "./AssetSelector.vue?vue&type=script&lang=js&"
export * from "./AssetSelector.vue?vue&type=script&lang=js&"
import style0 from "./AssetSelector.vue?vue&type=style&index=0&id=7bb39622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb39622",
  null
  
)

export default component.exports